// Form validation for Company contact form - MSP Configuration
import {
  emailValidator,
  nameValidator,
  phoneValidator,
  plaintextValidator
} from '../fields';

const config = { mandatory: true };

export default {
  firstName: plaintextValidator(config),
  lastName: plaintextValidator({}),
  email: emailValidator(config)
};
